var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:['skew-inline-main text-white skew-button', _vm.color],style:(_vm.setWidth()),on:{"click":_vm.handleClick}},[_c('span',{staticClass:"skew-inline"},[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }